import React from "react";
import Navbar from '../../components/Navbar';
import Footer from '../../components/Footer';
import BreadCrumb from '../../components/BreadCrumb';

const ProductDevelopment = () => {
    return (
        <div>
            <Navbar />
                <div class="container">
                    <BreadCrumb 
                        active_page="Product Development" 
                        prev_sub_page={{
                            'link':'/services',
                            'text':'Services'
                        }}
                        sub_page={{
                            'link':'/services/it-development-consulting',
                            'text':'IT Development & Consulting'
                        }} 
                    />
                    <div class="inner-container">
                        <h2>Product Development</h2>
                        <h3>Embrace Innovation</h3>
                        <p>Our product development engineers would guide you on how you can enhance your business with innovative technologies and stay ahead of the competition.</p>
                        <h3>Transform Design To Digital Product</h3>
                        <p>We are an amalgamate of designers, developers, testers, and marketing professionals under one roof. This creates a comprehensive way to launch products swifty and cost effectively.</p>
                        <h3>We’ll Amplify Your Product Value</h3>
                        <h3>Ideation</h3>
                        <p>Our team analyzes the problem your project is trying to solve and check if its user centered and in line with all its stakeholders</p>
                        <h3>Detailing</h3>
                        <p>Detailing or what we call as backlog is the vision of the product. This backlog is comprised of product backlog items. We elicit it in the form of use cases to identify, and organize system requirements.</p>
                        <h3>Manifestation</h3>
                        <p>During this phase we define the modules, and interfaces to initiate the process of development or altering systems along with processes, practices, and methodologies.</p>
                        <h3>Validate & Support</h3>
                        <p>This phase involves product releases, documentation, and training on skills, and processes. We offer 24 x 7 support and maintenance for the application.</p>


                    </div>
                </div>
            <Footer />
        </div>
    );
};

export default ProductDevelopment;